import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { VerifyEmailAPI } from "api/verification";

/**
 * Verify email using token from URL
 */
export const verifyEmail = createAsyncThunk(
  "verification/verifyEmail",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await VerifyEmailAPI({ token });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Email verification failed");
    }
  }
);

const verificationSlice = createSlice({
  name: "verification",
  initialState: {
    verifying: false,
    verified: false,
    error: null,
  },
  reducers: {
    resetVerificationState: (state) => {
      state.verifying = false;
      state.verified = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyEmail.pending, (state) => {
        state.verifying = true;
        state.verified = false;
        state.error = null;
      })
      .addCase(verifyEmail.fulfilled, (state) => {
        state.verifying = false;
        state.verified = true;
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.verifying = false;
        state.verified = false;
        state.error = action.payload;
      });
  },
});

export const { resetVerificationState } = verificationSlice.actions;

export default verificationSlice.reducer;
